import { createFileRoute } from "@tanstack/react-router";
import AnxietyNauseaPage from "@/pages/articles/AnxietyNauseaPage";
export const Route = createFileRoute(
  "/anxiety-nausea-why-it-happens-how-to-stop-it",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Anxiety Nausea: Why It Happens & How to Stop It | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Understand the gut-brain axis connection behind anxiety nausea. Learn immediate relief techniques and long-term psychiatric solutions to calm.",
        },
        {
          property: "og:title",
          content:
            "Anxiety Nausea: Why It Happens & How to Stop It | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Understand the gut-brain axis connection behind anxiety nausea. Learn immediate relief techniques and long-term psychiatric solutions to calm.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/anxiety-nausea-why-it-happens-how-to-stop-it",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/anxiety-nausea-why-it-happens-how-to-stop-it",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AnxietyNauseaPage />;
}
